import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Input} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {Actions} from '../../../common/actions';
import ProcessButton from './processButton';
import PartComposition from './composition';
import AddPartFilesModal from '../../../partsMaster/components/modals/addPartFilesModal';

class OrderRow extends Component {
  constructor(props) {
    super(props);
    this.state = {'quantity': props.order.quantity || 1, 'orderRepair': ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleChange(event, data) {
    this.setState({'quantity': parseInt(data.value, 10)});
  }

  handleChangeOrderRepair = (event, data) => {
    this.setState({'orderRepair': data.value.trim().toUpperCase()});
  }

  handleSelect() {
    const {order} = this.props;
    this.props.selectDealerEmergingOrderCode(order.code);
  }

  renderButton() {
    const {disabled, order} = this.props;
    const {quantity, orderRepair} = this.state;
    const mainCode = order.code;

    if (disabled || order.discontinued || order.allowDealersOrders !== 'S') {
      return null;
    }

    return (
      <ProcessButton quantity={quantity} orderRepair={orderRepair} order={order} mainCode={mainCode} />
    );
  }

  getLabel = (type) => {
    switch (type) {
      case 'original':
        return 'Código';
      case 'substitute':
        return 'Sustituto';
      default:
        return 'Equivalente';
    }
  }

  render() {
    const {type, order, disabled, loadingAttachments, rawAttachments, attachments} = this.props;
    const {quantity, orderRepair} = this.state;
    return (
      <Table.Row>
        <Table.Cell className='type-cell'>{this.getLabel(type)}</Table.Cell>
        <Table.Cell textAlign='center' className='select-emergent-code'>
          <a onClick={this.handleSelect}>{order.code}</a>
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {order.replacementCode ? order.replacementCode : '----'}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <PartComposition order={order} />
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {order.discontinued ? 'SI' : 'NO'}
        </Table.Cell>
        <Table.Cell>{order.name}</Table.Cell>
        <Table.Cell textAlign='center'>
          {order.stock >= quantity ? 'SI' : 'NO DISPONIBLE'}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          $ {getNumericValue(order.pvp, 2)}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {order.type ? order.type : '----'}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <Input
            size='mini'
            type='text'
            disabled={
              disabled || order.discontinued || !order.allowDealersOrders
            }
            value={orderRepair}
            onChange={this.handleChangeOrderRepair}
          />
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <Input
            size='mini'
            type='number'
            min={1}
            max={9999}
            disabled={
              disabled || order.discontinued || !order.allowDealersOrders
            }
            value={quantity}
            onChange={this.handleChange}
          />
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {order.haveFiles === 'S' ? (
            <AddPartFilesModal
              partCode={order.code}
              wasSearched={true}
              isUserTde={false}
              loadingAttachments={loadingAttachments}
              rawAttachments={rawAttachments}
              attachments={attachments}
            />
          ) : null}
        </Table.Cell>
        <Table.Cell textAlign='center'>{this.renderButton()}</Table.Cell>
      </Table.Row>
    );
  }
}

const {selectDealerEmergingOrderCode} = Actions;

const mapStateToProps = (state) => {
  return {
    'loadingAttachments': state.partsMaster.loadingAttachments,
    'rawAttachments': state.partsMaster.rawAttachments,
    'attachments': state.partsMaster.attachments,
  };
};

export default connect(mapStateToProps, {
  selectDealerEmergingOrderCode,
})(OrderRow);
